import React from "react";

const Terms = () => (
  <div className="max-w-3xl mx-auto p-6">
    <h1 className="text-3xl font-bold mb-4">Terms and Conditions</h1>
    <p className="mb-4">
      Welcome to TripsFlare! These terms and conditions outline the rules and regulations for the use of our website and services.
    </p>
    <h2 className="text-xl font-semibold mb-2">1. Acceptance of Terms</h2>
    <p className="mb-4">
      By accessing this website, we assume you accept these terms and conditions. Do not continue to use TripsFlare if you do not agree to all of the terms and conditions stated on this page.
    </p>
    <h2 className="text-xl font-semibold mb-2">2. Use of Services</h2>
    <p className="mb-4">
      You agree to use the services only for lawful purposes and in a manner that does not infringe the rights of, or restrict or inhibit the use and enjoyment of this site by, any third party.
    </p>
    <h2 className="text-xl font-semibold mb-2">3. Changes to Terms</h2>
    <p className="mb-4">
      We reserve the right to update or change these terms at any time. Your continued use of the service after such changes constitutes your acceptance of the new Terms and Conditions.
    </p>
    <p className="mt-6">Last updated: July 2025</p>
  </div>
);

export default Terms;
